import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    TOSWrapper: {
        paddingBottom: theme.spacing(3),
        '& a': {
            color: theme.palette.secondary.main,
            textDecoration: 'none',
            '&:hover': {
                color: theme.palette.secondary.dark,
                textDecoration: 'none',
            },
        },
    },
    actHealthColors: {
        '&$TOSWrapper a': {
            color: theme.palette.actHealth.main,
            '&:hover': {
                color: theme.palette.actHealth.dark,
            },
        },
    },
    submitButtonWrapper: {
        paddingTop: theme.spacing(4),
        width: '70%',
        marginLeft: '15%',
        boxSizing: 'border-box',
    },
    inputAdornment: {
        padding: theme.spacing(0, 1, 0, 1),
    },
}));
